export default __webpack_public_path__ + "static/media/ic-sm-fert-prod.e536eee2.svg";